import React from 'react';
import LegalLayout from '../components/layout/LegalLayout';

const sections = [
  { t: "Editeur du site", b: [
    { p: "mjkop.com est un site de fans, edite a titre personnel et non commercial par Sandy." },
    { p: "Contact : contact@mjkop.com" },
    { p: "Conformement a l'article 6, III, 2 de la loi pour la confiance dans l'economie numerique, l'editrice, personne physique agissant a titre non professionnel, a communique son identite complete a l'hebergeur et n'est pas tenue de la rendre publique." }
  ] },
  { t: "Directrice de la publication", b: [ { p: "Sandy." } ] },
  { t: "Hebergement", b: [
    { p: "Site et base de donnees : OVH SAS - 2 rue Kellermann, 59100 Roubaix, France - Telephone : +33 9 72 10 10 07." },
    { p: "Stockage des photos et videos : Cloudinary." }
  ] },
  { t: "Nature du site et absence d'affiliation", b: [
    { p: "mjkop.com est un site d'hommage et une communaute de fans dedies a la memoire de Michael Jackson. Il n'est ni affilie, ni soutenu, ni approuve par la succession de Michael Jackson, sa famille, ses ayants droit ou ses partenaires (maisons de disques, editeurs, etc.). Les noms, marques et images mentionnes appartiennent a leurs proprietaires respectifs et sont evoques dans un cadre d'hommage non commercial." }
  ] },
  { t: "Propriete intellectuelle", b: [
    { p: "La structure du site et ses elements originaux sont la propriete de l'editrice. Les contenus publies par les membres (textes, photos, videos) restent la propriete de leurs auteurs, seuls responsables de ce qu'ils publient. Toute reproduction non autorisee peut etre signalee a contact@mjkop.com." }
  ] },
  { t: "Donnees personnelles", b: [
    { p: "Le traitement de vos donnees est decrit dans la Politique de confidentialite. Vous pouvez y exercer vos droits a tout moment." }
  ] },
  { t: "Responsabilite", b: [
    { p: "L'editrice met tout en oeuvre pour assurer le bon fonctionnement du site mais ne peut garantir sa disponibilite permanente ni l'absence d'erreurs. Le site peut contenir des liens ou contenus de tiers dont l'editrice n'est pas responsable." }
  ] },
  { t: "Droit applicable", b: [ { p: "Le present site est soumis au droit francais." } ] }
];

export default function MentionsLegales() {
  return <LegalLayout titre="Mentions legales" sections={sections} />;
}
